import React from 'react';

import stylesPlain from './plain.module.css';

import Field from './Field';

import { getDefinedValue, getDefinedItem } from '../../util/tools';
import { getRefList, setRefList } from '../../util/localStorage';
import { performApiRequest, REFLIST_IS_ACTUAL_API_URL, REFLIST_LOAD_API_URL} from '../../util/restapi';
import { IET_SET_VALUE } from '../../util/realm/instance';

const INIT_STATE_STARTED = 'started';
const INIT_STATE_ERROR = 'error';
const INIT_STATE_COMPLETE = 'complete';

class FieldRefList extends Field {

	classId;
	listReferences = null;
	initErrorMessage = '';

	/*
		classId
		listId
		explicitList   
		styles
			label
			select                
	*/
	constructor(props) {
		super(props);
		this.state.value = this.field ? getDefinedItem( this, ['field', 'value', 'globalId'], '') : '';
		this.state.initState = INIT_STATE_STARTED;
	}
	completeComponentDidUpdate(prevProps, prevState, doInit) {
		if ( doInit ) {
			this.setState({ value: getDefinedItem( this, ['field', 'value', 'globalId'], '') });
		}
	}
	completeInit() {
		if( this.props.classId ) {
			this.classId = this.props.classId;
		} else if( this.field ) {
			let refClasses = this.field.model.refClasses;
			if( refClasses && refClasses.length > 0 )
				this.classId = refClasses[0];
		}
	}
	componentDidMount = async () => {
		super.componentDidMount();
		if( this.props.explicitList != null && this.props.explicitList != undefined ) {
			this.listReferences = [{id: 0, globalId: '', card: ''}, ...this.props.explicitList];
			this.setState({initState: INIT_STATE_COMPLETE});
			return;
		}
		if( ! this.classId ) {
			this.initErrorMessage = 'Unknown classId';
			this.setState( { initState: INIT_STATE_ERROR} );
			return;
		}
		let classId = this.classId;
		let listId = this.props.listId;
		if( listId == undefined || listId == null )
			listId = '';
		let list = getRefList(classId, listId);
		if( list != null ) {
			let request = {classId: classId, listId: listId, createTime: list.createTime};
			let response = await performApiRequest( REFLIST_IS_ACTUAL_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			if( ! response.data )
				list = null;
		}
		if( list == null ) {
			let request = {classId: classId, listId: listId};
			let response = await performApiRequest( REFLIST_LOAD_API_URL, request );
			if( ! response.success ) {
				this.initErrorMessage = response.message;
				this.setState( { initState: INIT_STATE_ERROR} );
				return;
			}
			list = response.data;
			setRefList(classId, listId, list);
		}
		this.listReferences = [{id: 0, globalId: '', card: ''}, ...list.list];
		this.setState({initState: INIT_STATE_COMPLETE});
	}
	
	handleInstanceChange = async (event) => {
		if( event.eventType == IET_SET_VALUE && event.field == this.field) {
			let newValue = event.newValue ? event.newValue.globalId : '';
			this.setState({ value: newValue });
		}
	}
	handleValueChange = e => {
		let value = e.target.value;
		if( value ) {
			let found = false;
			for( let ref of this.listReferences ) {
				if( ref.globalId == value ) {
					found = true;
					this.props.instance.setFieldValue( this.field, ref );
					break;
				}
				if( ! found )
					this.props.instance.setFieldValue( this.field, null );
			}
		} else
			this.props.instance.setFieldValue( this.field, null );
	}
	
	render() {
		if( this.field == null ) {
			return this.createDivUnknownField();
		}
		let selectHtml = null;
		if( this.state.initState == INIT_STATE_STARTED ) {
			selectHtml = (<span> ... </span>);
		} else if( this.state.initState == INIT_STATE_ERROR ) {
			selectHtml = (<span>{this.initErrorMessage}</span>);
		} else if( this.state.initState == INIT_STATE_COMPLETE ) {
			let optionsHtml = this.listReferences.map((ref, index) => {
				return (<option key={index} value={ref.globalId}>{ref.card}</option>);
			});
			let selectStyle = Object.assign({}, 
					getDefinedValue(this.props.styleSelect, {}), // Obsolete 
					getDefinedItem(this.props, ['styles', 'select']));
			let disabled = getDefinedValue(this.props.readOnly, false);
			selectHtml = (
				<select className={stylesPlain.selectEnum} style={selectStyle} 
					value={this.state.value} onChange={this.handleValueChange}
					disabled={disabled} 
				>
					{optionsHtml}
				</select>
			);
		}

		return (
			<React.Fragment>
				{this.createLabel()}
				{selectHtml}
			</React.Fragment>
		)
	}
}

export default FieldRefList; 